import { render, staticRenderFns } from "./SecurityOverviewSummary.vue?vue&type=template&id=48770b1b&"
import script from "./SecurityOverviewSummary.vue?vue&type=script&lang=js&"
export * from "./SecurityOverviewSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports